import { observer } from "mobx-react";
import React from "react";
import ChatIcon from "../../assets/chat-icon.svg";
import DocumentsWithCommentsIcon  from "../../assets/documents-list-icon.svg";
import { useAriaLabels } from "../../hooks/use-aria-labels";

import "./chat-panel-header.scss";
import "../themes.scss";

interface IProps {
  theme: string;
  newCommentCount: number;
  onCloseChatPanel:(show:boolean) => void;
  handleDocView: () => void;
  chatPanelTitle: string;
}

export const ChatPanelHeader: React.FC<IProps> = observer(({theme, newCommentCount, onCloseChatPanel,
  handleDocView, chatPanelTitle}) => {
  const ariaLabels = useAriaLabels();
  const renderNotification = () => {
    return (
      <div className="notification-toggle">
        <div className={`notification-icon themed-negative ${theme}`}>
          <DocumentsWithCommentsIcon
            className={`icon-image themed-negative ${theme}`}
            onClick={handleDocView}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="chat-panel-header" data-testid="chat-panel-header">
      <ChatIcon className={`chat-icon themed ${theme} no-action`}/>
      {chatPanelTitle}
      {renderNotification()}
      <button
        aria-label={ariaLabels.closeChatPanel}
        className={`chat-close-button themed ${theme}`}
        data-testid="chat-close-button"
        onClick={() => onCloseChatPanel(false)}
        type="button"
      />
    </div>
  );
});
